export default {
  routes: [{
    path: 'growth',
    name: 'growth',
    component: () => import('@/module/growth/GrowthIndex.vue'),
    meta: {
      title: '成长',
      keepAlive: true,
      logined: true
    }
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/growth.js